module.exports = __webpack_public_path__ + "components/outside-promo-page/static/Logotype-629ad9dca5433e5af5741ece5e1c0cf0.svg";